import React, { useState, useEffect } from 'react';
import { Render, FieldLabel, DropZone } from "@measured/puck";
import './styles/style.css';
import Svg from '../../../common/Svg';
import { Link, useNavigate , useParams } from 'react-router-dom';
import Logo from './images/Logo';
import Range from './components/Range';
import DateField from './components/DateField';
import {} from 'react-router-dom';

// Create Puck component config
const config = {
    categories: {
        Layout: {
            components: ["SinglePage", "WizardForm"],
        },
    },

    components: {


        //Form Layouts
        SinglePage: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "35px", value: "fs-35" },
                                { label: "40px", value: "fs-40" },
                                { label: "45px", value: "fs-45" },
                                { label: "50px", value: "fs-50" },
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        descriptionFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "22px", value: "fs-22" },
                                { label: "18px", value: "fs-18" },
                                { label: "16px", value: "fs-16" },
                                { label: "14px", value: "fs-14" },
                            ],
                        },
                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                            ],
                        },
                    },

                },
            },
            defaultProps: {
                Heading: {
                    title: "Heading goes here",
                    fontWeight: "fw-700",
                    titleFont: "fs-40",
                },

                Description: {
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                    descriptionFont: "fs-22",
                },

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                },

            },
            render: ({ Heading, Description, Padding }) => {

                return (
                    <>

                        <div className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`}>

                            <div className="container position-relative">
                                <div className="form-wrapper">
                                    <div className="section-heading mb-3 mb-md-4">
                                        <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        <p className={Description.descriptionFont}>{Description.text}</p>
                                    </div>
                                    <div className="form-inner">
                                        <DropZone zone="form-wrapper" disallow={["SinglePage", "WizardForm"]} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },


        WizardForm: {

            fields: {

                items: {
                    type: "array",
                    label: "Form Sections",
                    arrayFields: {
                        Title: { type: "text" },
                        Description: { type: "textarea" },
                    },
                    getItemSummary: (item) => item.Title || "Section",
                    defaultItemProps: {
                        Title: "Section title",
                        Description: "Section description",
                    },

                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                            ],
                        },
                    },

                },
            },
            defaultProps: {
                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                },
                items: [
                    { Title: "Company", Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. " },
                    { Title: "Technology", Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. " },
                    { Title: "Staff", Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. " },
                ]
            },
            render: ({ Padding, items }) => {
                return (
                    <>

                        <div className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`}>
                            <div className="container position-relative">
                                <ul className="nav nav-tabs" id="myTab" role="tablist">

                                    {items.map((item, i) => (
                                        <li className="nav-item" role="presentation" key={i}>
                                            {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                                            <button className={i === 0 ? 'nav-link active' : 'nav-link'} id={`tab-${i}`} data-bs-toggle="tab" data-bs-target={`#tab-${i}-pane`} type="button" role="tab" aria-controls={`tab-${i}-pane`} aria-selected="false">{item.Title}</button>
                                        </li>
                                    ))}
                                </ul>
                                <div className="form-wrapper">
                                    <div className="tab-content" id="myTabContent">
                                        {items.map((item, i) => (
                                            <div className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}>
                                                <div className="section-heading mb-3 mb-md-4">
                                                    <h2 className={`heading fw-700 fs-40`}>{item.Title}</h2>
                                                    <p className='fs-22'>{item.Description}</p>
                                                </div>
                                                <div className="form-inner">
                                                    <DropZone zone={`wizard-form-wrapper-${i}`} disallow={["SinglePage", "WizardForm"]} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </div>

                    </>
                )

            },
        },

        //Form Elements

        InputTextField: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                value: {
                    type: "custom",
                    label: "Value",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                hint: {
                    type: "custom",
                    label: "Hint",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <textarea
                                defaultValue={value}
                                className='form-control'
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}

                            />
                        </>
                    ),
                },

                conditionalLogic: {
                    type: "custom",
                    label: "Conditional Logic",
                    render: ({ field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="action-switch">
                                    <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                        <Svg name="edit-condition" />
                                    </button>
                                </div>

                            </div>
                        </>
                    ),
                },


                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Label",
                placeholder: "Placeholder",
                value: "Value",
                hint: '<p> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec eget augue ac sapien venenatis fringilla. Pellentesque congue imperdiet tortor nec maximus. <a href="http://" target="_blank" rel="noopener noreferrer">Click here</a> </p>',
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, value, placeholder, required, errorMessage, hint }) => {

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative">
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <div className="position-relative">
                                <input type="text" value={value} className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required} />
                                {hint &&
                                    <div className="hint">
                                        <button className="info"><Svg name="hint-button" /></button>
                                        <div className="popover" dangerouslySetInnerHTML={{ __html: hint }}>
                                        </div>
                                    </div>
                                }
                            </div>

                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        TextareaField: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                value: {
                    type: "custom",
                    label: "Value",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Textarea",
                value: "Value",
                placeholder: "Placeholder",
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, placeholder, required, errorMessage, value }) => {

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative">
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <textarea className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required} value={value} />

                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        Dropdown: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                items: {
                    type: "array",
                    label: "Options",
                    arrayFields: {
                        Option: { type: "text" },
                    },
                    getItemSummary: (item) => item.Option || "Options",
                    defaultItemProps: {
                        Option: "Enter option",
                    },
                },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Dropdown label",
                required: false,
                items: [
                    {
                        Option: "Option 1",
                    },
                    {
                        Option: "Option 2",
                    }

                ],
                // errorMessage: "Error message",
            },
            render: ({ label, required, errorMessage, items }) => {

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative">
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <select className={`form-control ${errorMessage ? 'error' : ''}`} >
                                <option value>--Select--</option>
                                {items.map((item, i) => (
                                    <option value={i}>{item.Option}</option>
                                ))}
                            </select>


                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },


        Checkbox: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                items: {
                    type: "array",
                    label: "Options",
                    arrayFields: {
                        Option: { type: "text" },
                    },
                    getItemSummary: (item) => item.Option || "Options",
                    defaultItemProps: {
                        Option: "Enter option",
                    },
                },

                ID: {
                    type: "custom",
                    label: "Unique ID",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Checkbox label",
                required: false,
                ID: 'CheckBox1',
                items: [
                    {
                        Option: "Option 1",
                    },
                    {
                        Option: "Option 2",
                    }

                ],
                // errorMessage: "Error message",
            },
            render: ({ label, required, errorMessage, items, ID }) => {

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative">
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}

                            <div className="roi-check-wrap">
                                {items.map((item, i) => (

                                    <div className="form-check" key={i}>
                                        <input className="form-check-input" name={ID} type="checkbox" defaultValue id={`${ID}-${i}`} />
                                        <label className="form-check-label" htmlFor={`${ID}-${i}`}>
                                            {item.Option}
                                        </label>
                                    </div>
                                ))}

                            </div>
                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        Radio: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                items: {
                    type: "array",
                    label: "Options",
                    arrayFields: {
                        Option: { type: "text" },
                    },
                    getItemSummary: (item) => item.Option || "Options",
                    defaultItemProps: {
                        Option: "Enter option",
                    },
                },

                ID: {
                    type: "custom",
                    label: "Unique ID",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Radio button label",
                required: false,
                ID: 'RadioButton1',
                items: [
                    {
                        Option: "Option 1",
                    },
                    {
                        Option: "Option 2",
                    }

                ],
                // errorMessage: "Error message",
            },
            render: ({ label, required, errorMessage, items, ID }) => {

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative">
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}

                            <div className="roi-check-wrap">
                                {items.map((item, i) => (

                                    <div className="form-check" key={i}>
                                        <input className="form-check-input" name={ID} type="radio" defaultValue id={`${ID}-${i}`} />
                                        <label className="form-check-label" htmlFor={`${ID}-${i}`}>
                                            {item.Option}
                                        </label>
                                    </div>
                                ))}

                            </div>
                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },


        PhoneNumber: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                value: {
                    type: "custom",
                    label: "Phone number",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },

                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Phone number",
                placeholder: "Enter phone number",
                value: "+91 3335 335353",
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, placeholder, required, errorMessage, value }) => {

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative">
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} />
                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        Email: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                value: {
                    type: "custom",
                    label: "Email",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },

                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Email",
                placeholder: "Enter email",
                value: "admin@testmail.com",
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, placeholder, required, errorMessage, value }) => {

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative">
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} />
                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        Date: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },


                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Date",
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, required, errorMessage }) => {

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative">
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                            <DateField />
                            {errorMessage && <div className="input-error">{errorMessage}</div>}

                        </div>
                    </>
                )

            },
        },

        Range: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Range",

                required: false,
            },
            render: ({ label, required }) => {

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative">
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                            <Range />

                        </div>
                    </>
                )

            },
        },

        Toggle: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },


            },
            defaultProps: {
                label: "Toggle button",
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, required }) => {

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative">
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <div className="check-switch">
                                <label>No</label>
                                <input
                                    id="agree-check"
                                    type="checkbox"
                                    defaultChecked
                                />
                                <label>Yes</label>

                            </div>

                        </div>
                    </>
                )

            },
        },

        Button: {
            fields: {
                Button: {
                    type: "object",
                    objectFields: {
                        buttonText: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                        buttonStyle: {
                            type: "radio",
                            label: "Style",
                            options: [
                                { label: "Primary", value: "primary" },
                                { label: "Secondary", value: "secondary" },
                            ],
                        },

                        buttonicon: {
                            type: "radio",
                            label: "Show icon",
                            options: [
                                { label: "Yes", value: "yes" },
                                { label: "No", value: "no" },
                            ],
                        },


                        icon: {
                            type: "custom",
                            label: "Icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type="file"
                                        id='uploadIcon'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadIcon" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <div className="icon-wrapper">
                                            {/** Default image **/}
                                            <Svg name="btn-upload-icn" />
                                        </div>
                                    </label>
                                </>
                            ),
                        },

                    },
                },

            },
            defaultProps: {
                Button: {
                    buttonText: "Button",
                    buttonLink: "https://www.google.com",
                    buttonStyle: "primary",
                    buttonicon: "yes",
                },
            },
            render: ({ Button }) => {

                return (
                    <>
                        <div className="button-wrap">
                            {Button.buttonicon === "yes" ?

                                <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
                                    <div className="icon">
                                        <Svg name="roi-button-icon" />
                                    </div>
                                </button>
                                :
                                <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
                            }

                        </div>
                    </>
                )

            },
        },


    },
};

// const dataForm = {
//     "content": [
//         {
//             "type": "PageHeader",
//             "props": {
//                 "id": "PageHeader-6e1337aa-2c6d-4473-bf4a-51b5dac9ceaf"
//             }
//         },
//         {
//             "type": "WizardForm",
//             "props": {
//                 "Padding": {
//                     "top": "pt-60",
//                     "bottom": "pb-60"
//                 },
//                 "items": [
//                     {
//                         "Title": "Company",
//                         "Description": "Innovating solutions with a global impact."
//                     },
//                     {
//                         "Title": "Technology",
//                         "Description": "Advanced tech driving tomorrow's markets."
//                     },
//                     {
//                         "Title": "Staff",
//                         "Description": "Expert teams dedicated to excellence."
//                     }
//                 ],
//                 "id": "WizardForm-daf72ca4-49d6-4a87-afcd-3ee2d767c921"
//             }
//         }
//     ],
//     "root": {},
//     "zones": {
//         "WizardForm-daf72ca4-49d6-4a87-afcd-3ee2d767c921:wizard-form-wrapper-0": [
//             {
//                 "type": "InputTextField",
//                 "props": {
//                     "label": "Company",
//                     "placeholder": "Enter company name",
//                     "value": "",
//                     "required": true,
//                     "id": "InputTextField-061cf30f-ff17-4c3e-a5f6-2d110edea1ec"
//                 }
//             },
//             {
//                 "type": "InputTextField",
//                 "props": {
//                     "label": "Annual revenue",
//                     "placeholder": "Enter snnual revenue",
//                     "value": "",
//                     "required": true,
//                     "id": "InputTextField-56f3fd65-90c0-4cd1-811d-0b58d330599a"
//                 }
//             },
//             {
//                 "type": "InputTextField",
//                 "props": {
//                     "label": "Number of customers",
//                     "placeholder": "Enter number of customers",
//                     "value": "",
//                     "required": true,
//                     "id": "InputTextField-4f42a7d5-0b1d-4236-9162-cda31fd8f1f7"
//                 }
//             },
//             {
//                 "type": "Button",
//                 "props": {
//                     "Button": {
//                         "buttonText": "Next",
//                         "buttonLink": "https://www.google.com",
//                         "buttonStyle": "primary",
//                         "buttonicon": "yes"
//                     },
//                     "id": "Button-622d1ff5-3169-46df-8e63-72c162259ee3"
//                 }
//             }
//         ],
//         "WizardForm-daf72ca4-49d6-4a87-afcd-3ee2d767c921:wizard-form-wrapper-1": [
//             {
//                 "type": "InputTextField",
//                 "props": {
//                     "label": "No. of different communication apps / devices per employee",
//                     "placeholder": "Enter here...",
//                     "value": "",
//                     "required": false,
//                     "id": "InputTextField-576c9eeb-b7a2-455f-9d9e-6fc61ef78e7b"
//                 }
//             },
//             {
//                 "type": "InputTextField",
//                 "props": {
//                     "label": "No. of communications downtime events per year",
//                     "placeholder": "Enter here...",
//                     "value": "",
//                     "required": true,
//                     "id": "InputTextField-685633a9-6fbb-49a5-b9c2-d801eed6627e"
//                 }
//             },
//             {
//                 "type": "Button",
//                 "props": {
//                     "Button": {
//                         "buttonText": "Next",
//                         "buttonLink": "https://www.google.com",
//                         "buttonStyle": "primary",
//                         "buttonicon": "yes"
//                     },
//                     "id": "Button-e9913716-b6d6-4f5c-8450-66f42fac5392"
//                 }
//             }
//         ],
//         "WizardForm-daf72ca4-49d6-4a87-afcd-3ee2d767c921:wizard-form-wrapper-2": [
//             {
//                 "type": "InputTextField",
//                 "props": {
//                     "label": "Number of work hours per year",
//                     "placeholder": "Enter here...",
//                     "value": "",
//                     "required": false,
//                     "id": "InputTextField-84fd5784-9435-49a6-8ce1-85da6c9e733a"
//                 }
//             },
//             {
//                 "type": "InputTextField",
//                 "props": {
//                     "label": "Number of work days per year",
//                     "placeholder": "Enter here...",
//                     "value": "",
//                     "required": false,
//                     "id": "InputTextField-790eaf5e-35bf-4291-93d4-ebea2b2a5503"
//                 }
//             },
//             {
//                 "type": "InputTextField",
//                 "props": {
//                     "label": "Number of communications related downtime hours per year",
//                     "placeholder": "Enter here...",
//                     "value": "",
//                     "required": false,
//                     "id": "InputTextField-cfa02754-0bba-49e1-a242-c22e99476f47"
//                 }
//             },
//             {
//                 "type": "InputTextField",
//                 "props": {
//                     "label": "Employee cost (pension, benefits, resources)",
//                     "placeholder": "Enter here...",
//                     "value": "",
//                     "required": false,
//                     "id": "InputTextField-60e4a7c5-1c6c-4c79-8a47-fe238beea217"
//                 }
//             },
//             {
//                 "type": "InputTextField",
//                 "props": {
//                     "label": "Annual office worker salary",
//                     "placeholder": "Enter here...",
//                     "value": "",
//                     "required": false,
//                     "id": "InputTextField-0973b90d-ff62-44a1-9c58-ad276d1688bd"
//                 }
//             },
//             {
//                 "type": "InputTextField",
//                 "props": {
//                     "label": "Annnual IT worker salary",
//                     "placeholder": "Enter here...",
//                     "value": "",
//                     "required": false,
//                     "id": "InputTextField-d2e9c640-9a45-4907-91c0-5e8e19db3021"
//                 }
//             },
//             {
//                 "type": "InputTextField",
//                 "props": {
//                     "label": "Office employee turnover each year",
//                     "placeholder": "Enter here...",
//                     "value": "",
//                     "required": false,
//                     "id": "InputTextField-79419cfb-f820-4a86-9e06-88cb3ca6223a"
//                 }
//             },
//             {
//                 "type": "Button",
//                 "props": {
//                     "Button": {
//                         "buttonText": "Submit",
//                         "buttonLink": "https://www.google.com",
//                         "buttonStyle": "primary",
//                         "buttonicon": "yes"
//                     },
//                     "id": "Button-439eea4b-a2db-46ca-861f-8e2db46c687d"
//                 }
//             }
//         ]
//     }
// }

const dataForm = {
    "content": [
        {
            "type": "PageHeader",
            "props": {
                "id": "PageHeader-d5200f26-81bf-4747-b91b-3a27d843c8e0"
            }
        },
        {
            "type": "WizardForm",
            "props": {
                "Padding": {
                    "top": "pt-60",
                    "bottom": "pb-60"
                },
                "items": [
                    {
                        "Title": "Company",
                        "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. "
                    },
                    {
                        "Title": "Technology",
                        "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. "
                    },
                    {
                        "Title": "Staff",
                        "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. "
                    }
                ],
                "id": "WizardForm-3bcde9a1-e5eb-416c-86fa-a8917876d09c"
            }
        }
    ],
    "root": {},
    "zones": {
        "WizardForm-3bcde9a1-e5eb-416c-86fa-a8917876d09c:wizard-form-wrapper-0": [
            {
                "type": "InputTextField",
                "props": {
                    "label": "Label",
                    "placeholder": "Placeholder",
                    "value": "Value",
                    "hint": "<p> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec eget augue ac sapien venenatis fringilla. Pellentesque congue imperdiet tortor nec maximus. <a href=\"http://\" target=\"_blank\" rel=\"noopener noreferrer\">Click here</a> </p>",
                    "required": false,
                    "id": "InputTextField-de8356e9-c7fb-4c3d-98ea-4fcf14bffe24"
                }
            },
            {
                "type": "TextareaField",
                "props": {
                    "label": "Textarea",
                    "value": "Value",
                    "placeholder": "Placeholder",
                    "required": false,
                    "id": "TextareaField-8f8ddcf2-7d40-4148-b6c2-3179abd4807d"
                }
            },
            {
                "type": "Dropdown",
                "props": {
                    "label": "Dropdown label",
                    "required": false,
                    "items": [
                        {
                            "Option": "Option 1"
                        },
                        {
                            "Option": "Option 2"
                        }
                    ],
                    "id": "Dropdown-bf155481-8c34-4569-ae8d-5a8aa755dcf3"
                }
            },
            {
                "type": "PhoneNumber",
                "props": {
                    "label": "Phone number",
                    "placeholder": "Enter phone number",
                    "value": "+91 3335 335353",
                    "required": false,
                    "id": "PhoneNumber-f293ecc3-8499-4a47-8552-e89bc16d29ea"
                }
            },
            {
                "type": "Radio",
                "props": {
                    "label": "Radio button label",
                    "required": false,
                    "ID": "RadioButton1",
                    "items": [
                        {
                            "Option": "Option 1"
                        },
                        {
                            "Option": "Option 2"
                        }
                    ],
                    "id": "Radio-5223b9d5-b2d7-4b82-a17e-9691accddf51"
                }
            },
            {
                "type": "Date",
                "props": {
                    "label": "Date",
                    "required": false,
                    "id": "Date-f1811e62-c06d-4f3e-9e54-583cfb643ef4"
                }
            },
            {
                "type": "Range",
                "props": {
                    "label": "Range",
                    "required": false,
                    "id": "Range-7de42626-4c7a-46be-937e-743bf14d331d"
                }
            },
            {
                "type": "Toggle",
                "props": {
                    "label": "Toggle button",
                    "required": false,
                    "id": "Toggle-437a3027-02aa-4888-9935-a4d1d7f985fb"
                }
            },
            {
                "type": "Button",
                "props": {
                    "Button": {
                        "buttonText": "Button",
                        "buttonLink": "https://www.google.com",
                        "buttonStyle": "primary",
                        "buttonicon": "yes"
                    },
                    "id": "Button-900e7603-949b-42da-bae1-6e526a60ae92"
                }
            }
        ],
        "WizardForm-3bcde9a1-e5eb-416c-86fa-a8917876d09c:wizard-form-wrapper-1": [
            {
                "type": "Radio",
                "props": {
                    "label": "Radio button label",
                    "required": false,
                    "ID": "RadioButton1",
                    "items": [
                        {
                            "Option": "Option 1"
                        },
                        {
                            "Option": "Option 2"
                        }
                    ],
                    "id": "Radio-cb5fc990-8b6c-4062-9558-dc0c3ef0a8cc"
                }
            },
            {
                "type": "Toggle",
                "props": {
                    "label": "Toggle button",
                    "required": false,
                    "id": "Toggle-8450bd21-4a6e-4948-8c88-e53c24a5f74e"
                }
            },
            {
                "type": "Button",
                "props": {
                    "Button": {
                        "buttonText": "Button",
                        "buttonLink": "https://www.google.com",
                        "buttonStyle": "primary",
                        "buttonicon": "yes"
                    },
                    "id": "Button-e480f6a7-8888-4577-a876-76e167dbd082"
                }
            }
        ],
        "WizardForm-3bcde9a1-e5eb-416c-86fa-a8917876d09c:wizard-form-wrapper-2": [
            {
                "type": "Dropdown",
                "props": {
                    "label": "Dropdown label",
                    "required": false,
                    "items": [
                        {
                            "Option": "Option 1"
                        },
                        {
                            "Option": "Option 2"
                        }
                    ],
                    "id": "Dropdown-a5c6d743-1bba-461d-aa33-133f8c50ffe2"
                }
            },
            {
                "type": "Checkbox",
                "props": {
                    "label": "Checkbox label",
                    "required": false,
                    "ID": "CheckBox1",
                    "items": [
                        {
                            "Option": "Option 1"
                        },
                        {
                            "Option": "Option 2"
                        }
                    ],
                    "id": "Checkbox-38630d11-1ac5-4824-8f0c-0767c2c8c131"
                }
            },
            {
                "type": "Button",
                "props": {
                    "Button": {
                        "buttonText": "Button",
                        "buttonLink": "https://www.google.com",
                        "buttonStyle": "primary",
                        "buttonicon": "yes"
                    },
                    "id": "Button-58cbbc99-0298-4acc-899a-d2eb3a72dd5b"
                }
            }
        ]
    }
}

export default function ROIForm() {
    const { roiId } = useParams()
    console.log(roiId,"dsdds");
    const navigate = useNavigate();

    const [renderData, setRenderData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);


    // Handler to navigate to /roi/report
    const handleNavigate = () => navigate('/roi/report');

    useEffect(() => {
        checkIdAndActiveStatusInDatabase();
    }, [roiId]); // Depend on roiId so that the effect runs again if it changes

    const checkIdAndActiveStatusInDatabase = async () => {
        try {
            const apiUrl = process.env.REACT_APP_NODE_API_URL;
            const response = await fetch(`${apiUrl}/roi-pages/detail/${roiId}`);
            const data = await response.json();
            console.log("data",data);
            setRenderData(JSON.parse(data.result?.[0]?.structure))
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }


    return (
        <>
        <Render config={config} data={dataForm} onButtonClick={handleNavigate} />
        </>
    );

}
